const commonProps = {
  toString() {
    return `${this.msg} [${this.code}]`;
  }
};

export const CODE_WEIXIN_KEY_NOT_EXISTS = {
  ...commonProps,
  code: "800910",
  dev_msg: "微信授权key不存在! 请确保在微信下授权已完成!",
  msg: "微信授权失败"
};

export default {
  [CODE_WEIXIN_KEY_NOT_EXISTS.code]: CODE_WEIXIN_KEY_NOT_EXISTS
};



// WEBPACK FOOTER //
// ./src/consts/error_codes.js